<template>
  <select>
    <slot></slot>
  </select>
</template>
<script>

import $ from 'jquery'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import feedbackMixin from "../mixins/feedback"

Vue.use(VueAxios, axios)

export default {
  name: "NDCSelect2",
  props: {
    value: String,
    description: String,
    strength: String,
    schedule: String,
    uom: String,
    packSize: Number,
    registration: String,
  },
  mixins: [feedbackMixin],
  mounted: function () {
    $('.modal-content').removeAttr('tabIndex')
    let vm = this
    $(this.$el)
        // init select2
        .select2(
            {
              templateResult: function (state) {
                if (!state.id) {
                  return state.text
                }
                console.log('Select2 state: ' + JSON.stringify(state))
                return $('<div style="font-weight: bold;">' + state.text + '</div><div style="font-size: smaller;">' + state.description + '</div><div style="font-size: smaller">Schedule ' + state.schedule + '<span style="border-left: rgba(0, 0, 0, 0.25) thin solid; margin-left: 0.25em; padding-left: 0.25em; display: inline;">UoM ' + state.uom + '</span></div>')
              },
              ajax: {
                delay: 250,
                processResults: function (data, params) {
                  console.log('Select2 processResults data:')
                  console.log(JSON.stringify(data))
                  let resultObject = {}
                  let resultArray = []

                  let sourceArray = data.data.data
                  if (sourceArray && sourceArray.length > 0) {
                    let scriptResult = JSON.parse(data.data.scriptResult)
                    let foundCount = scriptResult.foundCount
                    console.log('NDC Select Found Count: ' + foundCount)
                    let page = (params.data && params.data.page) || 1
                    let morePages = 100 * page < foundCount

                    let pagination = {
                      'more': morePages
                    }

                    console.log('Source array: ' + JSON.stringify(sourceArray))
                    for (let property in sourceArray) {
                      let foundIndex = resultArray.findIndex(element => {
                        return element.id === sourceArray[property].fieldData['NDC Code LU']
                      });
                      if (foundIndex === -1) {
                        resultArray.push({
                          'id': sourceArray[property].fieldData['NDC Code LU'],
                          'text': sourceArray[property].fieldData['NDC Code LU'],
                          'description': sourceArray[property].fieldData['Trade Name Final LU'],
                          'schedule': sourceArray[property].fieldData['CSA Schedule LU'],
                          'uom': sourceArray[property].fieldData['Package Size UoM LU'],
                          'UoMVL': sourceArray[property].fieldData.UoM_VL,
                          'strength': sourceArray[property].fieldData.Strength,
                          'packSize': sourceArray[property].fieldData['Package Size Converted LU'],
                          'removedFromArcos': sourceArray[property].fieldData['Removed From ARCOS']
                        })
                      }
                    }
                    resultObject.pagination = pagination
                  }
                  resultObject.results = resultArray
                  console.log('Result object')
                  console.log(JSON.stringify(resultObject))
                  return resultObject
                },
                transport: function (params, success, failure) {
                  console.log('Select2 transport params:')
                  console.log(JSON.stringify(params))
                  let token = vm.token
                  let page = params.data.page || 1
                  let offset = page * 100 + 1

                  let ndc_search_criterion = params.data.term ? params.data.term : vm.value;

                  if (!ndc_search_criterion) {
                    ndc_search_criterion = "*"
                  }

                  console.log("vm.registration", vm.registration)

                  let query = {
                    searchCriteria: [
                      {
                        omit: false,
                        criteria: {
                          "NDC CODE LU": ndc_search_criterion
                        }
                      },
                      {
                        omit: false,
                        criteria: {
                          "Trade Name Final LU": ndc_search_criterion
                        }
                      },
                      {
                        omit: true,
                        criteria: {
                          "Removed From ARCOS": "1"
                        }
                      },
                    ],
                    search: true,
                    registration: vm.registration,
                  }

                  if (page > 1) {
                    query.offset = offset
                  }
                  query.limit = 100

                  if (ndc_search_criterion) {
                    Vue.axios.get('/3ds/api/dictionaries',
                        {
                          headers: {
                            'Authorization': 'Bearer ' + token
                          },
                          responseType: 'json',
                          params: {
                            query: query
                          }
                        }
                    ).then(response => {
                      console.log('Select2 response:')
                      console.log(JSON.stringify(response))
                      success(response)
                      response.abort = function (statusText) {
                        console.log('Aborted with statusText ' + response.statusText)
                      }
                      return response
                    }).catch(error => {
                      failure()

                      error.response.abort = function (statusText) {
                        console.log('Aborted with statusText ' + error.response.statusText)
                      }
                      return error.response
                    });
                  }
                }
              }
            }
        )
        .val(this.value)
        .trigger('change')
        // emit event on change.
        .on('change', function () {
          console.log('On NDCSelect2 change')
          let ndcSelect = $(vm.$el);
          let selectedData = ndcSelect.select2('data')
          if (selectedData.length > 0) {
            console.log("Selected data", selectedData[0])
            vm.$emit('input', selectedData[0].id)
            vm.$emit('schedule', selectedData[0].schedule)
          } else {
            console.log("vm", vm)
            vm.$emit('input', vm.value)
            vm.$emit('schedule', vm.schedule)
            vm.selectInitialValue(vm.value, ndcSelect)
          }
        })
        .on('select2:select', function () {
          console.log('On NDCSelect2 selected')
          let selectedData = ndcSelect.select2('data');
          // vm.$emit('set-selected-chemical', {
          //   selectedChemical: selectedData[0],
          // })
          console.log(JSON.stringify(selectedData))
          if (selectedData.length > 0) {
            let valueList = selectedData[0].UoMVL
            if (valueList) {
              vm.$emit('ndc-select-value-list', {
                valueList: valueList.split('\r'),
                selectionChanged: !selectedData[0].selected,
                selectedChemical: selectedData[0],
              })
            } else {
              vm.$emit('ndc-select-value-list', {
                valueList: null,
                selectionChanged: !selectedData[0].selected
              })
            }
          }
        })
    let ndcSelect = $(this.$el)
    let value = this.value
    this.selectInitialValue(value, ndcSelect);
  },
  methods: {
    selectInitialValue: function (value, ndcSelect) {
      if (value) {
        let data = this.props

        let option = new Option(value, value, true, true);
        ndcSelect.append(option).trigger('change');

        // manually trigger the `select2:select` event
        ndcSelect.trigger({
          type: 'select2:select',
          params: {
            data: data
          }
        });
      }
    },
  },
  watch: {
    value: function (value) {
      // update value
      $(this.$el)
          .val(value)
          .trigger('change')
    }
  },
  destroyed: function () {
    $(this.$el).off().select2('destroy')
  }
}
</script>

<style>
.select2-close-mask {
  z-index: 2099 !important;
}

.select2-dropdown {
  z-index: 3051 !important;
}

.select2-selection {
  height: 38px !important;
  padding-top: 0.25rem;
}

.select2-selection__arrow {
  margin-top: 0.25rem;
}

.select2-selection__arrow b {
  color: rgba(0, 0, 0, 1);
}

.select2-container {
  z-index: 10000;
}

.select2-results {
  max-height: 400px !important;
}

/*.select2-dropdown {
  width: 300px !important;
}*/
</style>